import React from "react"

import Layout from "../components/Layout"

const AboutPage = props => (
  <Layout>
    <h1>Inicio &#128587;</h1>
    <p>
      Informe seu e-mail e senha para se conectar. Se não tiver uma conta,
      escolha <strong>CRIAR UMA CONTA</strong> e informe seu e-mail, nome e
      senha. Vai receber um código por e-mail para confirmação da conta.
    </p>
    <p>
      Logo após a conexão, poderá começar a usar o aplicativo livremente. A
      opção <strong>COMO FUNCIONA</strong> mostra uma tela simples de ajuda e a
      opção <strong>COMECE A USAR</strong> direciona para a tela principal.
    </p>
    <p>
      Na parte de cima à direita da tela está o ícone &#9776; que abre o menu
      lateral à esquerda da tela. Este menu dá acesso a várias funções do
      aplicativo:
    </p>
    <p>
      <ul>
        <li>
          <strong>Dados pessoais</strong> - Sua foto e dados pessoais;
        </li>
        <li>
          <strong>Protetores</strong> - Registro de protetors. Voce pode se
          cadastrar aqui e todos os animais que colocar para adoção estarão
          agrupados sobre sua conta, facilitando o contato de quem quer adotar;
        </li>
        <li>
          <strong>Registro de adoção</strong> - Todas as adoções que você fizer
          como doador ficam registradas aqui;
        </li>
        <li>
          <strong>Animais adotados</strong> - Mostra todos os animais que foram
          registrados como adotados;
        </li>
        <li>
          <strong>Busca geral</strong> - Permite realizar buscas gerais por
          animais na sua área por características físicas;
        </li>
        <li>
          <strong>Resumo</strong> - Mostra os totais por região e situação;
        </li>
        <li>
          <strong>Preferências</strong> - Opções de uso do aplicativo;
        </li>
        <li>
          <strong>Trocar a senha</strong> - Possibilita mudar sua senha de
          acesso;
        </li>
        <li>
          <strong>Desativar conta</strong> - Se não quiser mais usar o
          aplicativo, pode excluir sua conta aqui;
        </li>
      </ul>
    </p>
  </Layout>
)

export default AboutPage
